import React from 'react';
import Navber from '../Components/Navber';
import { NavLink, Routes, Route,Outlet } from 'react-router-dom';
import "../Styles/Profile.css";
import { FaUserEdit, FaHotel, FaHiking, FaCogs, FaSignOutAlt, FaMapMarkedAlt } from "react-icons/fa";


function Profile() {
          const customer = JSON.parse(localStorage.getItem("customer"));
    console.log("customer", customer);
  return (
    <div>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>

      <div className="profilePage_container">
        {/* Sidebar */}
<div className="profilePage_sidebar">
  <NavLink 
    to="/profile" 
    end
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaUserEdit className="profilePage_icon" />Profile
  </NavLink>

  <NavLink 
    to="/profile/tour-info" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaMapMarkedAlt className="profilePage_icon" /> Tours
  </NavLink>

  <NavLink 
    to="/profile/hotel-info" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaHotel className="profilePage_icon" /> Hotel
  </NavLink>

  <NavLink 
    to="/profile/activity-info" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaHiking className="profilePage_icon" /> Activity
  </NavLink>
 {customer?.is_franchise ? (
  <NavLink 
    to="/profile/franchise" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaUserEdit className="profilePage_icon" /> Franchise
  </NavLink>
) : null}

  <NavLink 
    to="/profile/settings" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaCogs className="profilePage_icon" /> Settings
  </NavLink>

  <NavLink 
    to="/profile/logout" 
    className={({ isActive }) => 
      isActive ? "profilePage_link logout active" : "profilePage_link logout"
    }
  >
    <FaSignOutAlt className="profilePage_icon" /> Logout
  </NavLink>
</div>


        {/* Right-side Content */}
        <div className="profilePage_content">
            <Outlet/>
        </div>
      </div>
    </div>
  );
}

export default Profile;
